import React, { Component } from 'react';
import { View, TouchableOpacity, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isString as _isString, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon, Badge } from '@vfgroup-oneplatform/foundation/Components';
import {
  LightThemeColors,
  withTheme,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './AddOnsCard.Styles';

class AddonsCard extends Component {
  renderCardBody = () => {
    const { renderCardBody, item, secondTextStyle } = this.props;
    const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

    if (_isFunction(renderCardBody)) {
      return renderCardBody(item);
    }

    return (
      <VFText
        i18nKey={item?.subtext ?? 'addons_sub_text'}
        placeHolders={[currencyTransformer(item.price, 0), item.duration]}
        style={[styles.secondText, secondTextStyle]}
      />
    );
  };

  render() {
    const {
      onPress,
      item,
      style,
      theme,
      leftIconStyle,
      rightIconStyle,
      leftIconSize,
      rightIconSize,
      topTextStyle,
      images,
      withStatusBadge,
      renderAddOnsCardFooter,
      omitLongText,
    } = this.props;
    const isValidAddOn = addOn => {
      return addOn.name && addOn.price;
    };
    if (!isValidAddOn(item)) {
      return null;
    }

    const _images = getThemeImages(theme.name);
    const _icon = _isString(item.icon) ? images[item.icon] : item.icon;

    return (
      <TouchableWithoutFeedback onPress={onPress} testID={item.name}>
        <View
          style={[styles.cardContainerStyle(theme), style]}
          testID={`${item.name}${FrameworkTestKeys.AddOn}`}
        >
          <View style={styles.secondCardContainer}>
            <View style={styles.icon}>
              <Icon
                style={[styles.leftIcon, leftIconStyle]}
                name={_icon}
                type="image"
                size={leftIconSize || 34}
              />
            </View>
            <View style={styles.text}>
              <VFText
                style={[styles.topText, topTextStyle]}
                i18nKey={item.name}
                {...(omitLongText && { numberOfLines: 1 })}
              />
              {this.renderCardBody()}

              {withStatusBadge && item.status === 'inactive' && (
                <Badge
                  text="addons_inactive_status"
                  type="neutral"
                  style={styles.badgeStyle}
                  textStyle={styles.badgeTextStyle}
                />
              )}
            </View>
            <View>
              <TouchableOpacity onPress={onPress}>
                <Icon
                  style={[styles.arrowIcon, rightIconStyle]}
                  name={_images.ic_chevron_right_red}
                  type="image"
                  size={rightIconSize || 33}
                />
              </TouchableOpacity>
            </View>
          </View>
          {_isFunction(renderAddOnsCardFooter) && renderAddOnsCardFooter()}
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

AddonsCard.defaultProps = {
  theme: LightThemeColors,
  item: { duration: 'addons_default_addon_duration' },
  withStatusBadge: false,
  omitLongText: false,
};

AddonsCard.propTypes = {
  item: PropTypes.object,
  leftIconStyle: ViewPropTypes.style,
  topTextStyle: ViewPropTypes.style,
  secondTextStyle: ViewPropTypes.style,
  rightIconStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  onPress: PropTypes.func,
  images: PropTypes.object,
  rightIconSize: PropTypes.number,
  leftIconSize: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withStatusBadge: PropTypes.bool,
  renderCardBody: PropTypes.func,
  renderAddOnsCardFooter: PropTypes.func,
  omitLongText: PropTypes.bool,
};

export default withTheme(AddonsCard);
